import { Component } from '@angular/core';

@Component({
  selector: 'manual-file-picker-example',
  template: `<file-picker-modal></file-picker-modal>
    <div class="form-block">
      <file-picker-standalone
        (fileChange)="onFileChange($event)"
        [file]="file"
        [label]="'example'"
        [key]="'example'"
      ></file-picker-standalone>
    </div>`,
})
export class StandaloneFilePickerExample {
  file = {
    currName: 'something.exe',
    currContent: null,
  };

  onFileChange(evt) {
    console.log(evt);
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/standalone-file-picker-example.component.ts